<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Check in e Check out' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-grid class="gradient-container" style="margin-top: -49px;">
    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">
          {{pessoa.id ? pessoa.nome : ("Nenhuma Pessoa Selecionada" |
          translate)}}
        </p>

        <h5 *ngIf="pessoa.entidade == 'grupoxpessoa' " class="user-tipo">
          {{'Participante' | translate}}
        </h5>
        <h5 *ngIf="pessoa.entidade == 'grupoxvisitante' " class="user-tipo">
          {{'Visitante' | translate}}
        </h5>
        <h5 *ngIf="pessoa.entidade == 'projetoxvisitanteesporadico' " class="user-tipo">
          {{'Esporádico' | translate}}
        </h5>

        <p class="bold-1" *ngIf="isMenor">{{'Menor de Idade' | translate}}</p>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto" class="index">
        <div>
          <ion-button *ngIf="!pessoa.checkin" (click)="check();" expand="block" class="btn-default">
            {{'Realizar Check-in' | translate}}
          </ion-button>

          <ion-button *ngIf="pessoa.checkin && !pessoa.checkout" (click)="check();" expand="block" class="btn-default">
            {{'Realizar Check-out' | translate}}
          </ion-button>

          <div *ngIf="pessoa.checkin && pessoa.checkout" class="finalizado">
            {{'Finalizado' | translate}}
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-sign-out-alt div-icon"></i>
          </ion-note>

          <ion-label class="color-title">
            {{'Dados do Check-in' | translate}}
          </ion-label>
        </div>
      </ion-col>

      <ion-grid class="dados-check">
        <div *ngIf="pessoa.checkin">
          <ion-row>
            <ion-col size="12">
              <p class="item-title one-line bold-2">
                {{'Check-in realizado' | translate}}
              </p>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <div class="icon-display">
                <i class="fa-solid fa-clock icon-list"></i>

                <p class="text-list">
                  {{pessoa.checkin | dateFormat:'mediaHora'}}
                </p>
              </div>
            </ion-col>

            <ion-col *ngIf="pessoa.checkinObs">
              <div class="icon-display">
                <i class="fa-solid fa-circle-info icon-list"></i>

                <p class="text-list">{{pessoa.checkinObs}}</p>
              </div>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="pessoa.checkinResponsavel" (click)="detalhesResponsavel(pessoa.checkinResponsavel)">
            <ion-col size="auto">
              <div class="icon-display">
                <i class="fa-solid fa-circle-info icon-list"></i>

                <p class="text-list">{{pessoa.nomeCheckinResponsavel}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>

        <ion-row *ngIf="!pessoa.checkin">
          <ion-col size="12">
            <p>{{'Check-in Não Realizado' | translate}}</p>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-item-divider></ion-item-divider>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-sign-in-alt div-icon"></i>
          </ion-note>

          <ion-label class="color-title">
            {{'Dados do Check-out' | translate}}
          </ion-label>
        </div>
      </ion-col>

      <ion-grid class="dados-check">
        <div *ngIf="pessoa.checkout">
          <ion-row>
            <ion-col size="12">
              <p class="item-title one-line bold-2">
                {{'Check-out realizado' | translate}}
              </p>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <div class="icon-display">
                <i class="fa-solid fa-clock icon-list"></i>

                <p class="text-list">
                  {{pessoa.checkout | dateFormat:'mediaHora'}}
                </p>
              </div>
            </ion-col>

            <ion-col *ngIf="pessoa.checkoutObs">
              <div class="icon-display">
                <i class="fa-solid fa-circle-info icon-list"></i>

                <p class="text-list">{{pessoa.checkoutObs}}</p>
              </div>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="pessoa.checkoutResponsavel" (click)="detalhesResponsavel(pessoa.checkoutResponsavel)">
            <ion-col size="auto">
              <div class="icon-display">
                <i class="fa-solid fa-circle-info icon-list"></i>

                <p class="text-list">{{pessoa.nomeCheckoutResponsavel}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>

        <ion-row *ngIf="!pessoa.checkout">
          <ion-col size="12">
            <p>{{'Check-out Não Realizado' | translate}}</p>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-item-divider></ion-item-divider>
    </ion-row>
  </ion-grid>
</ion-content>